/**
 * Enum for months of the year.
 * @enum {number}
 */
export const MES = {
  JANEIRO: 0,
  FEVEREIRO: 1,
  MARÇO: 2,
  ABRIL: 3,
  MAIO: 4,
  JUNHO: 5,
  JULHO: 6,
  AGOSTO: 7,
  SETEMBRO: 8,
  OUTUBRO: 9,
  NOVEMBRO: 10,
  DEZEMBRO: 11,
};
